<template>
    <client-page className="header--light">
        
        <sub-visual
        sh="인재채용"
        tabActive="현직자 인터뷰"
        bg="/images/sub/visual/sv4-5.jpg">
        </sub-visual>

        <div class="text-center color-white bg-point py-50 py-lg-74 w-100">
            <v-container>
                <h3 class="tit font-weight-bold font-italic" data-aos="fade-down">
                    <strong class="font-weight-bold">도전하는 사람들의 이야기  </strong>
                </h3>
                <p class="tit-txt mt-10 mt-lg-24" data-aos="fade-up">
                    세일즈웍스 코리아와 함께하는 사람들의 <br class="d-none d-md-block">
                    생생한 이야기를 들어보세요.
                </p>
            </v-container>
        </div>

        <section class="section">
            <v-container>
                <manager-interview class="mb-50 mb-lg-100" />
                <branch-interview class="mb-50 mb-lg-100" />
                <head-interview class="mb-50 mb-lg-100" />
                <!-- <job-interview /> -->
            </v-container>
        </section>

	</client-page>
</template>

<script>

import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import ManagerInterview from "@/components/client/interview/manager-interview.vue"
import BranchInterview from "@/components/client/interview/branch-interview.vue"
import HeadInterview from "@/components/client/interview/head-interview.vue"
// import JobInterview from "@/components/client/interview/job-interview.vue"

export default {
	components: {
        ClientPage,
        SubVisual,
        ManagerInterview,
        BranchInterview,
        HeadInterview,
        // JobInterview
    },
}
</script>
